// https://developers.facebook.com/docs/marketing-api/dynamic-product-ads/product-audiences#setuppixel
// https://developers.facebook.com/docs/facebook-pixel/reference

// When a product is added to the shopping cart.
function fb_addToCart(productObject,pageName){
  if((!($.isEmptyObject(productObject))) && productObject !== null &&productObject.sellingPrice !== undefined && parseInt(productObject.sellingPrice) > 0){
    var id = productObject.productId;
    var title = productObject.productTitle;
    var sku = productObject.productSku;
    var category = productObject.productType;
    var price = productObject.sellingPrice;
    var brand = productObject.productBrand;
    
    if (pageName !== undefined && pageName !== "") {
      var updatedListName = (pageName.split(" ").join("_")).toUpperCase();
      if (updatedListName === "COLLECTION_RESULTS") {
        price = getSellingPrice(id);
      }
    }
    
    
    
    if (price !== undefined && price !== 0 && parseInt(price) > 0) {
      fbq('track', 'AddToCart', {
          content_name: title,
          content_category: category,
          content_ids: [sku],
          content_type: 'product',
          value: price,
          currency: 'INR'
       }); 
    } else {
      var errorString = "fb_handler issue: pid:"+id+" SKU:"+sku
      Sentry.captureException(new Error(errorString));
    }
  
  }
}

// pageview for cart page
function fb_viewContect(productObject){
  if((!($.isEmptyObject(productObject))) &&
     productObject.sellingPrice !== undefined && parseInt(productObject.sellingPrice) > 0){
    var id = productObject.productId;
    var title = productObject.productTitle;
    var sku = productObject.productSku;
    var category = productObject.productType;
    var price = (parseFloat(productObject.sellingPrice)).toFixed(2);
    var brand = productObject.productBrand;
    
    let updatedBrandName = (brand.split(" ").join("_")).toUpperCase();
    if (updatedBrandName !== "PRADE_JEWELS") {
      fbq('track', 'ViewContent', {
          content_name: title,
          content_category: category,
          content_ids: [sku],
          content_type: 'product',
          value: price,
          currency: 'INR'
       });
    }
   
  }
}

// When a product is added to a wishlist.
function fb_moveToWishList(productObject,pageName){
  if((!($.isEmptyObject(productObject))) && 
     productObject.sellingPrice !== undefined && parseInt(productObject.sellingPrice) > 0){
    var id = productObject.productId;
    var title = productObject.productTitle;
    var sku = productObject.productSku;
    var category = productObject.productType;
    var price = productObject.sellingPrice;
    var brand = productObject.productBrand;
    
    if (pageName !== undefined && pageName !== "") {
      var updatedListName = (pageName.split(" ").join("_")).toUpperCase();
      if (updatedListName === "COLLECTION_RESULTS") {
        price = getSellingPrice(id);
      }
    }
   
    if (price !== undefined && price !== 0 && parseInt(price) > 0) {
      fbq('track', 'AddToWishlist', {
          content_name: title,
          content_ids: [sku],
          content_type: 'product',
          value: price,
          currency: 'INR'
       });
      
      let gaObj = {};
    gaObj["productId"] = id;
    gaObj["productTitle"] = title;
    gaObj["productSku"] = sku;
    gaObj["productType"] = category;
    gaObj["sellingPrice"] = price;
    gaObj["productBrand"] = brand;
    ga_moveToWishlist(gaObj);
      
    } 
  }
}

// user click on move to wishlist in the cart
function fb_CartMoveToWishList(lineItemObj){
  if(!($.isEmptyObject(lineItemObj))){
    var title = "";
    var sku = "";
    var price = lineItemObj.unitPrice;
    if(lineItemObj.title !== null){
      title = lineItemObj.title;
    }
    if(lineItemObj.sku !== null){
      sku = lineItemObj.sku;
    }
    
    fbq('track', 'AddToWishlist', {
        content_name: title,
        content_ids: [sku],
        content_type: 'product',
        value: price,
        currency: 'INR'
     });
    ga_cartMoveToWishlist(lineItemObj);
  }
}

// user click on cart checkout button
function fb_cartCheckout(lineItemsArray,cartValueObj){
  var fbPixelData = [];
  var lineItemsArrayLength = lineItemsArray.length;
  var i;
  for(i=0; i<lineItemsArrayLength; i++){
    if(!($.isEmptyObject(lineItemsArray[i]))){
      var lineItemObj = lineItemsArray[i];
      var sku = "";
      var price = "";
      var quantity = "";
      if(lineItemObj.sku !== null){
        sku = lineItemObj.sku;
      }
      if(lineItemObj.unitPrice !== null){
        price = lineItemObj.unitPrice;
      }
      if(lineItemObj.quantity !== null){
        quantity = lineItemObj.customerEnteredQuantity;
      }
      var pixelProduct = {};
      pixelProduct["id"] = sku;
      pixelProduct["quantity"] = quantity;
      pixelProduct["item_price"] = price;
      
      fbPixelData.push(pixelProduct);
    }
  }
  
  fbq('track', 'InitiateCheckout', {
      contents:fbPixelData,
      content_type: 'product',
      value: cartValueObj.cart_subtotal_value,
      currency: 'INR'
    });
}

// track payment options
function fb_paymentOption(paymentOption){
  fbq('track',paymentOption);
}

// when order is created
function fb_purchase(data){
  var fbPixelData = [];
  var orderObj = data.order;
  var totalPrice = orderObj.total_price;
  var lineItemsArray = orderObj.line_items;
  var ordersArrayLength = lineItemsArray.length;
  var i;
  for(i = 0; i < ordersArrayLength; i++) {
    var product = lineItemsArray[i];
    var sku = product.sku;
    var quantity = product.quantity;
    var price = product.price;
    
    var pixelProduct = {};
    pixelProduct["id"] = sku;
    pixelProduct["quantity"] = quantity;
    pixelProduct["item_price"] = price;
    
    fbPixelData.push(pixelProduct);
  }
  
  fbq('track', 'Purchase', {
      contents:fbPixelData,
      content_type: 'product',
      value: totalPrice,
      currency: 'INR'
    });
}


//  ----------------- get selling price -------------

function getSellingPrice(pid) {
  if (collectionPriceResult !== undefined && collectionPriceResult !== null &&
      collectionPriceResult.length > 0) {
    var price = 0;
    for (let variantObj of collectionPriceResult){
      if (variantObj !== undefined && Object.keys(variantObj).length >0) {
        if (variantObj.product_id === pid) {
          if (variantObj.is_variant_in_sale ) {
            price = (parseFloat(variantObj.variant_sale_price)).toFixed(2)
            break;
//             return (parseFloat(variantObj.variant_sale_price)).toFixed(2);
          } else {
            price = (parseFloat(variantObj.price)).toFixed(2);
            break;
//             return (parseFloat(variantObj.price)).toFixed(2);
          }
        }
      }
  }
    return price
  }
};
